import {
  Box,
  Button,
  Container,
  Grid,
  Text,
  Heading,
  VStack,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { PricingDetailRow } from "./PricingDetailRow";
import { BirdNestIcon } from "../LandingPage/BirdNestIcon";
import { startCase } from "lodash";
import { DashDivider } from "../LandingPage/DashDivider";
import { XIcon } from "lucide-react";
import Link from "next/link";

export const PricingDetails = ({ plans }: { plans?: any[] }) => {
  const t = useTranslations("Pricing");
  const raw = useTranslations();

  return (
    <Box
      w="full"
      px={{
        base: 4,
        md: 16,
      }}
      py={{
        base: 8,
        md: 16,
      }}
      pt={{
        base: 4,
        md: 0,
      }}
      bgColor="brand.100"
      color="brand.1000"
      id="features"
    >
      <Container maxW="container.xl">
        <Grid
          gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }}
          mb={12}
          gap={{
            base: 8,
            md: 24,
          }}
        >
          <Box>
            <Heading color="brand.1000" fontWeight={400}>
              {t("ourCoachingPlan")}
            </Heading>
          </Box>
          <Box>
            <Text fontSize={"lg"} color="brand.1000">
              {t("ourCoachingPlanDescription")}
            </Text>
          </Box>
        </Grid>
        <Box
          w="full"
          display={{
            base: "none",
            md: "block",
          }}
        >
          <PricingDetailRow
            hideBorder
            label=""
            value1={
              <Text fontWeight={600} mb={4} fontSize="xl">
                {raw("roles.coach")}
              </Text>
            }
            value2={
              <Text fontWeight={600} mb={4} fontSize="xl">
                {raw("roles.coach")}
              </Text>
            }
            value3={
              <Text fontWeight={600} mb={4} fontSize="xl">
                {raw("roles.master_coach")}
              </Text>
            }
          />
        </Box>
        <Heading fontSize={"lg"} color="brand.1000" mb={4}>
          {t("managementSoftware")}
        </Heading>
        <Box w="full" overflowX={"auto"}>
          <Box
            w="full"
            fontFamily={"Gotham"}
            display={{
              base: "block",
              md: "none",
            }}
          >
            <PricingDetailRow
              hideBorder
              label=""
              value1={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {plans?.[0]?.name!}
                </Text>
              }
              value2={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {plans?.[1]?.name!}
                </Text>
              }
              value3={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {plans?.[2]?.name!}
                </Text>
              }
            />
          </Box>
          <PricingDetailRow
            label={t("clientPerCoach")}
            value1={10}
            value2={30}
            value3={5}
          />

          <PricingDetailRow
            label={t("clientPerTeamLeader")}
            value1={<XIcon width={32} height={32} color="#A7A9AC" />}
            value2={<XIcon width={32} height={32} color="#A7A9AC" />}
            value3={5}
          />
          <PricingDetailRow
            label={t("addCoachesToTeam")}
            value1={<XIcon width={32} height={32} color="#A7A9AC" />}
            value2={<XIcon width={32} height={32} color="#A7A9AC" />}
            value3={t("upTo", { qty: 4 })}
          />
          <PricingDetailRow
            label={t("sessionNotes")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />

          <PricingDetailRow
            label={t("sessionHistory")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("insertGoalsAndTracking")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("scheduleSessions")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("createClientsAndPackages")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("sendRemindersToClients")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("moodTracker")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("receipts")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("shareableAndCustomizableForms")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("uploadResourcesForClients")}
            value1={t("upTo", { qty: 3 })}
            value2={startCase(raw("unlimited"))}
            value3={startCase(raw("unlimited"))}
          />
        </Box>

        <Heading fontSize={"lg"} color="brand.1000" mb={4} mt={8}>
          {t("coachBusinessCenter")}
        </Heading>
        <Box w="full" overflowX={"auto"}>
          <Box
            w="full"
            display={{
              base: "block",
              md: "none",
            }}
          >
            <PricingDetailRow
              hideBorder
              label=""
              value1={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {raw("roles.coach")}
                </Text>
              }
              value2={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {raw("roles.coach")}
                </Text>
              }
              value3={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {raw("roles.master_coach")}
                </Text>
              }
            />
          </Box>
          <PricingDetailRow
            label={t("dashboard")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />

          <PricingDetailRow
            label={t("teamDashboard")}
            value1={<XIcon width={32} height={32} color="#A7A9AC" />}
            value2={<XIcon width={32} height={32} color="#A7A9AC" />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />

          <PricingDetailRow
            label={t("salesFunnel")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("financialPlan")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("referralsProgram")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />

          <PricingDetailRow
            label={t("teamCoachesEvaluation")}
            value1={<XIcon width={32} height={32} color="#A7A9AC" />}
            value2={<XIcon width={32} height={32} color="#A7A9AC" />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
        </Box>
        <Heading fontSize={"lg"} color="brand.1000" mb={4} mt={8}>
          {t("learningAndDevelopment")}
        </Heading>
        <Box w="full" overflowX={"auto"}>
          <Box
            w="full"
            display={{
              base: "block",
              md: "none",
            }}
          >
            <PricingDetailRow
              hideBorder
              label=""
              value1={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {raw("roles.coach")}
                </Text>
              }
              value2={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {raw("roles.coach")}
                </Text>
              }
              value3={
                <Text fontWeight={600} mb={4} fontSize="lg">
                  {raw("roles.master_coach")}
                </Text>
              }
            />
          </Box>
          <PricingDetailRow
            label={t("library")}
            value1={t("includesCoachingLibrary")}
            value2={t("includesCoachingLibrary")}
            value3={t("includesCoachingLibrary")}
          />

          <PricingDetailRow
            label={t("selfAwarenessTests")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("platformLives")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          <PricingDetailRow
            label={t("platformCourses")}
            value1={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value2={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
            value3={<BirdNestIcon fill={"#A7A9AC"} width={32} height={32} />}
          />
          {/* <PricingDetailRow
            label="Paid Courses and Trainings"
            value1={"Against Purchase"}
            value2={"Against Purchase"}
            value3={"Against Purchase"}
          /> */}

          <PricingDetailRow
            label={t("createLives")}
            value1={<XIcon width={32} height={32} color="#A7A9AC" />}
            value2={<XIcon width={32} height={32} color="#A7A9AC" />}
            value3={`${t("upTo", { qty: 4 })}/${raw("date.month")}`}
          />
          <PricingDetailRow
            label={t("createCourses")}
            value1={<XIcon width={32} height={32} color="#A7A9AC" />}
            value2={<XIcon width={32} height={32} color="#A7A9AC" />}
            value3={`${t("upTo", { qty: 2 })}/${raw("date.month")}`}
          />
        </Box>
        <VStack
          gap={16}
          py={{
            base: 8,
            md: 16,
          }}
        >
          <DashDivider />
          <BirdNestIcon width={60} height={60} />
          <Link href="/signup">
            <Button
              size="lg"
              fontSize="2xl"
              w={{
                base: "full",
                md: "auto",
              }}
              variant={"primary"}
            >
              {t("wantClarifayo")}
            </Button>
          </Link>
        </VStack>
      </Container>
    </Box>
  );
};
